import { Command } from 'commander';
import chalk from 'chalk';
import { setupApiKey, loadConfig, resetConfig } from '../config.js';

export const configCommand = new Command('config')
  .description('Manage VibeTime CLI configuration')
  .action(async () => {
    // Default action: show current configuration
    const config = loadConfig();
    
    console.log(chalk.cyan('\n📋 Current Configuration\n'));
    
    if (config.apiKey) {
      console.log(chalk.green('✓') + ' API Key: ' + chalk.gray(`...${config.apiKey.slice(-8)}`));
    } else {
      console.log(chalk.red('✗') + ' API Key: ' + chalk.gray('Not configured'));
    }
    
    console.log('  API Endpoint: ' + chalk.gray(config.apiEndpoint || 'Default'));
    console.log('\n' + chalk.gray('Run `vibetime config set` to change configuration'));
  });

// サブコマンド: set
configCommand
  .command('set')
  .description('Set API key and configuration interactively')
  .action(async () => {
    await setupApiKey(true);
  });

// サブコマンド: reset
configCommand
  .command('reset')
  .description('Reset all configuration')
  .action(() => {
    resetConfig();
  });

// サブコマンド: show
configCommand
  .command('show')
  .description('Show current configuration')
  .action(() => {
    const config = loadConfig();
    console.log(chalk.cyan('\n📋 Configuration:\n'));
    console.log(JSON.stringify(config, null, 2));
  });